<template>
  <div class="phonebg">
    <div v-if="code != 1">
      <el-form ref="form" :model="form" label-width="80px">
        <div class="confirmBill" style="color: red">
          ¥{{ amount | returnFloat }}
        </div>
        <div class="PersonalLine">
          <div>抬头类型</div>
          <el-button
            size="mini"
            @click="headUpType(1)"
            :class="{ clickHeadUpType: isHeadUp == 1 }"
            >个人</el-button
          >
          <el-button
            size="mini"
            @click="headUpType(0)"
            :class="{ clickHeadUpType: isHeadUp == 0 }"
            >单位</el-button
          >
        </div>
        <div v-if="isHeadUp == 1">
          <div class="PersonalLine">
            <div>
              <span class="sign">*</span>
              收票方名称
            </div>
            <input v-model="personalForm.khmc" placeholder="收票方名称(必填)" />
          </div>

          <div class="PersonalLine">
            <div>客户邮件</div>
            <input v-model="personalForm.khyj" placeholder="客户邮件" />
          </div>
          <div class="PersonalLine">
            <div>客户手机号</div>
            <input v-model="personalForm.khsj" placeholder="客户手机号" />
          </div>
          <span class="arbitrarily">邮件、手机号任填一项！</span>
          <div class="PersonalLine">
            <div><span class="sign">*</span>开票项目</div>
            <select v-model="personalXm.flbm" @change="changPersonalXm">
              <option
                :value="item.flbm"
                v-for="(item, index) in voiceList"
                :key="index"
              >
                {{ item.cpmc }}
              </option>
            </select>
          </div>
          <div class="PersonalLine">
            <div>产品名称</div>
            <input v-model="personalXm.cpmc" placeholder="产品名称(必填)" />
          </div>
          <div class="PersonalLine">
            <div>产品规格</div>
            <input v-model="personalXm.cpxh" placeholder="产品规格(必填)" />
          </div>
          <div class="PersonalLine">
            <div>产品单位</div>
            <input v-model="personalXm.cpdw" placeholder="产品单位(必填)" />
          </div>
          <div class="PersonalLine">
            <div>数量</div>
            <input
              v-model="personalXm.cpsl"
              placeholder="数量(必填)"
              type="number"
            />
          </div>
          <div class="PersonalLine beizhu">
            <div>备注</div>
            <textarea v-model="personalForm.bz" placeholder="备注"></textarea>
          </div>
          <div class="confirmBill">
            <el-button type="primary" @click="confirmBill" size="mini"
              >确认开票</el-button
            >
          </div>
        </div>
        <!-- 单位 -->
        <div v-if="isHeadUp == 0">
          <div class="PersonalLine">
            <div>
              <span class="sign">*</span>
              收票方名称
            </div>
            <input v-model="companyForm.khmc" placeholder="收票方名称(必填)" />
          </div>
          <div class="PersonalLine">
            <div>收票方税号</div>
            <input v-model="companyForm.khsh" placeholder="收票方税号" />
          </div>
          <div class="PersonalLine">
            <div>收票方地址</div>
            <input v-model="companyForm.khdz" placeholder="收票方地址" />
          </div>
          <div class="PersonalLine">
            <div>收票方电话</div>
            <input v-model="companyForm.khdh" placeholder="收票方电话" />
          </div>
          <div class="PersonalLine">
            <div>收票方银行账号</div>
            <input
              v-model="companyForm.khkhyhzh"
              placeholder="收票方银行账号"
            />
          </div>
          <div class="PersonalLine">
            <div>收票方银行名称</div>
            <input
              v-model="companyForm.bankinfo"
              placeholder="收票方银行名称"
            />
          </div>

          <div class="PersonalLine">
            <div>客户邮件</div>
            <input v-model="companyForm.khyj" placeholder="客户邮件" />
          </div>
          <div class="PersonalLine">
            <div>客户手机号</div>
            <input v-model="companyForm.khsj" placeholder="客户手机号" />
          </div>
          <span class="arbitrarily">邮件、手机号任填一项！</span>
          <!-- <div class="PersonalLine">
            <div>开票方式</div>
            <select v-model="companyForm.kpfs">
              <option value="0">异步</option>
              <option value="1">同步</option>
            </select>
          </div> -->
          <div class="PersonalLine">
            <div><span class="sign">*</span>开票项目</div>
            <select v-model="companyXm.flbm" @change="changCompanyXmXm">
              <option
                :value="item.flbm"
                v-for="(item, index) in voiceList"
                :key="index"
              >
                {{ item.cpmc }}
              </option>
            </select>
          </div>
          <div class="PersonalLine">
            <div>产品名称</div>
            <input v-model="companyXm.cpmc" placeholder="产品名称(必填)" />
          </div>
          <div class="PersonalLine">
            <div>产品规格</div>
            <input v-model="companyXm.cpxh" placeholder="产品规格(必填)" />
          </div>
          <div class="PersonalLine">
            <div>产品单位</div>
            <input v-model="companyXm.cpdw" placeholder="产品单位(必填)" />
          </div>
          <div class="PersonalLine">
            <div>数量</div>
            <input
              v-model="companyXm.cpsl"
              placeholder="数量(必填)"
              type="number"
            />
          </div>
          <div class="PersonalLine beizhu">
            <div>备注</div>
            <textarea v-model="companyForm.bz" placeholder="备注"></textarea>
          </div>
          <div class="confirmBill">
            <el-button type="primary" @click="dwConfirmBill" size="mini"
              >确认开票</el-button
            >
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import global from "../../Global.vue";
import { checkInput, checkPhone, checkEmail } from "../../assets/js/commonJS";
export default {
  data() {
    return {
      amount: "",
      code: "",
      isHeadUp: 1,
      form: {},
      billingTypeList: [{ name: "11", value: 0 }],
      personalForm: {
        kpfs: "1",
      },
      companyForm: {
        kpfs: "1",
      },
      voiceList: [],
      getvoiceinfo: {},
      getCompanyVoiceinfo: {},
      personalXm: {
        cpmc: "房间",
        cpxh: "间",
        cpdw: "间",
        cpsl: "1",
        flbm: "",
      },
      companyXm: {
        cpmc: "房间",
        cpxh: "间",
        cpdw: "间",
        cpsl: "1",
        flbm: "",
      },
      // 加盟号
      joinCode: "",
      configId: "",
    };
  },
  created() {
    this.queryresults();
    this.amount = this.$route.query.amount;
  },
  mounted() {},
  filters: {
    returnFloat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        return value;
      }
    },
  },
  methods: {
    headUpType(val) {
      if (val == 1) {
        
        this.isHeadUp = 1;
      } else {
        
        this.isHeadUp = 0;
      }
    },
    // 查询开票结果
    queryresults() {
      // return
      let prams = {
        key: "bwhis8888",
        batchNo: this.$route.query.batchNo,
        hotelId: this.$route.query.hotelId,
      };
      this.axios.post(global.api + "getInvoiceNo", prams).then((res) => {
        if (res.status == 200) {
          this.code = res.data.data.code;
          // 获取加盟号
          this.joinCode = res.data.data.joinCode;
          this.getConfigId();
        } else {
          this.$message({
            message: res.data.message,
            center: true,
          });
        }
      });
    },
    // 根据加盟号对应的配置信息
    getConfigId() {
      this.axios
        .get(
          global.invoice + "invoiceConfig/selectAll?joinCode=" + this.joinCode
        )
        .then((res) => {
          if (res.status == 200) {
            this.configId = res.data.data.id;
            this.getInvoiceList();
          } else {
            this.$message({
              message: res.message,
              center: true,
            });
          }
        });
    },
    // 获取项目列表
    getInvoiceList() {
      this.axios
        .get(global.invoice + "invoiceItem/selectAll?configId=" + this.configId)
        .then((res) => {
          if (res.status == 200) {
            this.voiceList = res.data.data;
            this.personalXm.flbm = this.voiceList[0].flbm;
            this.companyXm.flbm = this.voiceList[0].flbm;
          } else {
            this.$message({
              message: res.message,
              center: true,
            });
          }
        });
    },
    changPersonalXm() {
      this.voiceList.forEach((item) => {
        if (item.flbm == this.personalXm.flbm) {
          this.getvoiceinfo = item;
        }
      });
    },
    changCompanyXmXm() {
      this.voiceList.forEach((item) => {
        if (item.flbm == this.companyXm.flbm) {
          this.getCompanyVoiceinfo = item;
        }
      });
    },
    // 个人确认开票
    confirmBill() {
      var perKhmc = this.personalForm.khmc;
      // 非必填
      var perCpmc = this.personalXm.cpmc;
      var perCpxh = this.personalXm.cpxh;
      var perCpdw = this.personalXm.cpdw;
      var perCpsl = this.personalXm.cpsl;
      var perflbm = this.personalXm.flbm;
      // 手机邮箱
      var perKhdh = this.personalForm.khdh;
      var perKhyj = this.personalForm.khyj;
      var perKhsj = this.personalForm.khsj;
      if (
        !checkInput(perKhmc) ||
        // !checkInput(perCpmc) ||
        // !checkInput(perCpxh) ||
        // !checkInput(perCpdw) ||
        // !checkInput(perCpsl) ||
        !checkInput(perflbm)
      ) {
        this.$message({
          message: "请填写必填信息",
          type: "warning",
          center: true,
        });
      } else if (perKhyj == undefined && perKhsj == undefined) {
        this.$message({
          message: "客户邮件或请填写客户手机号",
          type: "warning",
          center: true,
        });
      } else if (!checkPhone(perKhdh) && perKhdh != undefined) {
        this.$message({
          message: "请填写正确手机号码",
          type: "warning",
          center: true,
        });
      } else if (!checkPhone(perKhsj) && perKhsj != undefined) {
        this.$message({
          message: "请填写正确手机号码",
          type: "warning",
          center: true,
        });
      } else if (!checkEmail(perKhyj) && perKhyj != undefined) {
        this.$message({
          message: "请填写正确邮件号",
          type: "warning",
          center: true,
        });
      } else {
        // 
        if (this.personalXm.cpsl == null) {
          this.personalXm.cpsl = 0;
        }
        let voicePrams = {
          key: "bwhis8888",
          hotelId: this.$route.query.hotelId,
          batchNo: this.$route.query.batchNo,
          amount: this.$route.query.amount,
          xtlsh: this.$route.query.hotelId + "-" + this.$route.query.batchNo,
          khmc: this.personalForm.khmc,
          khsh: this.personalForm.khsh,
          khdz: this.personalForm.khdz,
          khdh: this.personalForm.khdh,
          khkhyhzh: this.personalForm.khkhyhzh,
          bankinfo: this.personalForm.bankinfo,
          bz: this.personalForm.bz,
          khyj: this.personalForm.khyj,
          khsj: this.personalForm.khsj,
          kpfs: this.personalForm.kpfs,
          item: [
            {
              cpmc: this.personalXm.cpmc,
              cpxh: this.personalXm.cpxh,
              cpdw: this.personalXm.cpdw,
              sl: this.getvoiceinfo.sl,
              cpsl: this.personalXm.cpsl,
              // bhsje: this.personalXm.bhsje,
              // se: this.personalXm.se,
              flbm: this.getvoiceinfo.flbm,
              xsyh: this.getvoiceinfo.xsyh,
              lslbz: this.getvoiceinfo.lslbz,
              yhsm: this.getvoiceinfo.yhsm,
            },
          ],
        };
        
        this.axios.post(global.api + "doInvoice", voicePrams).then((res) => {
          if (res.status == 100) {
            this.$message({
              message: res.data.message,
              center: true,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.message,
              center: true,
            });
          }
        });
      }
    },
    // 单位确认开票
    dwConfirmBill() {
      var perKhmc = this.companyForm.khmc;
      var perCpmc = this.companyXm.cpmc;
      var perCpxh = this.companyXm.cpxh;
      var perCpdw = this.companyXm.cpdw;
      var perCpsl = this.companyXm.cpsl;
      var perflbm = this.companyXm.flbm;
      // 手机邮箱
      var perKhdh = this.companyForm.khdh;
      var perKhyj = this.companyForm.khyj;
      var perKhsj = this.companyForm.khsj;
      if (
        !checkInput(perKhmc)
        // ||
        // !checkInput(perCpmc) ||
        // !checkInput(perCpxh) ||
        // !checkInput(perCpdw) ||
        // !checkInput(perCpsl) ||
        // !checkInput(perflbm)
      ) {
        this.$message({
          message: "请填写必填信息",
          type: "warning",
          center: true,
        });
      } else if (perKhyj == undefined && perKhsj == undefined) {
        this.$message({
          message: "客户邮件或请填写客户手机号",
          type: "warning",
          center: true,
        });
      } else if (!checkPhone(perKhdh) && perKhdh != undefined) {
        this.$message({
          message: "请填写正确收票方手机号码",
          type: "warning",
          center: true,
        });
      } else if (!checkPhone(perKhsj) && perKhsj != undefined) {
        this.$message({
          message: "请填写正确客户手机号码",
          type: "warning",
          center: true,
        });
      } else if (!checkEmail(perKhyj) && perKhyj != undefined) {
        this.$message({
          message: "请填写正确邮件号",
          type: "warning",
          center: true,
        });
      } else {
        if (this.personalXm.cpsl == null) {
          this.personalXm.cpsl = 0;
        }
        let voicePrams = {
          key: "bwhis8888",
          hotelId: this.$route.query.hotelId,
          batchNo: this.$route.query.batchNo,
          amount: this.$route.query.amount,
          xtlsh: this.$route.query.hotelId + "-" + this.$route.query.batchNo,
          khmc: this.companyForm.khmc,
          khsh: this.companyForm.khsh,
          khdz: this.companyForm.khdz,
          khdh: this.companyForm.khdh,
          khkhyhzh: this.companyForm.khkhyhzh,
          bankinfo: this.companyForm.bankinfo,
          bz: this.companyForm.bz,
          khyj: this.companyForm.khyj,
          khsj: this.companyForm.khsj,
          kpfs: this.companyForm.kpfs,
          item: [
            {
              cpmc: this.companyXm.cpmc,
              cpxh: this.companyXm.cpxh,
              cpdw: this.companyXm.cpdw,
              sl: this.getCompanyVoiceinfo.sl,
              cpsl: this.companyXm.cpsl,
              // bhsje: this.personalXm.bhsje,
              // se: this.personalXm.se,
              flbm: this.getCompanyVoiceinfo.flbm,
              xsyh: this.getCompanyVoiceinfo.xsyh,
              lslbz: this.getCompanyVoiceinfo.lslbz,
              yhsm: this.getCompanyVoiceinfo.yhsm,
            },
          ],
        };
        
        // return;
        this.axios.post(global.api + "doInvoice", voicePrams).then((res) => {
          if (res.status == 100) {
            this.$message({
              message: res.data.message,
              center: true,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.message,
              center: true,
            });
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.fizeweight {
  font-weight: bold;
}
.phonebg {
  background: #eeeeee;
  padding: 15px;
  overflow: scroll;
  /* background: linear-gradient(180deg, #D6EBFF, #E9F4FF 48%, #D6EBFF); */
}
.jiudian {
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
}
.title {
  text-align: center;
  font-weight: bold;
  font-size: 1.2rem;
  height: 3rem;
  line-height: 3rem;
}
.content {
  border-radius: 8px;
  margin: 0% 3%;
  line-height: 2rem;
  padding: 5%;
  color: #575f6b;
  font-size: 1rem;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  /* box-shadow: 8px 8px 20px #b9ccec inset, -8px -8px 15px #ffffff inset; */
  text-align: center;
}

.weixin,
.user {
  margin-top: 1rem;
  position: relative;
}
.name {
  font-weight: bold;
  font-size: 1.2rem;
}

.face {
  width: 4rem;
  border-radius: 100%;
}
.contentuser {
  display: flex;
  border-radius: 8px;
  margin: 0% 3%;
  line-height: 2rem;
  padding: 3%;
  color: #575f6b;
  font-size: 1rem;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
}
.divface {
  margin-right: 3%;
}
.faceuser {
  width: 4rem;
  height: 5rem;
  margin-top: 6%;
}

.qrbd {
  width: 30%;
  color: #4bb0ff;
  text-align: center;
  margin-top: 0.5rem;
  border-radius: 0.2em;
  box-shadow: 5px 5px 20px #a2b3dc, -5px -5px 20px #ffffff;
  position: absolute;
  right: 5%;
  bottom: 10%;
  height: 2rem;
  line-height: 2rem;
}
>>> input,
select {
  border: none !important;
  box-shadow: none !important;
  /* border-bottom: 1px solid #e4e4e4 !important; */
  background-color: #fff;
  width: 62%;
  height: 30px;
  /* appearance:none; */
  outline: none;
  font-size: 16px;
}
textarea {
  width: 62%;
  height: 70px;

  border: none !important;
  box-shadow: none !important;
}
.beizhu {
  height: 80px !important;
  /* background-color: royalblue; */
  display: flex;
  align-items: center;
}
.confirmBill {
  text-align: center;
  margin-top: 15px;
  font-size: 30px;
}
.clickHeadUpType {
  border: 1px solid #66c19c;
  color: #66c19c;
}
.PersonalLine {
  height: 50px;
  line-height: 50px;
}
.PersonalLine > div {
  width: 35%;
  display: inline-block;
  font-weight: bold;
}
.PersonalLine > input {
  font-size: 16px;
  color: #000;
}
.sign {
  color: red;
}
.arbitrarily {
  color: red;
  font-size: 12px;
}
</style>